import { Tag } from "lucide-react";
import { useSiteSettings } from "../lib/useSiteSettings";

export default function PriceHint({ slug }) {
  const { prices } = useSiteSettings();
  const price = prices?.[slug];
  if (!price) return null;
  return (
    <div
      data-testid="service-price-hint"
      className="mt-6 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-[#E5EBE5] shadow-sm text-sm text-[#1A2E1C]"
    >
      <Tag className="w-4 h-4 text-[#1B5E20]" />
      Tarif indicatif : <strong className="font-semibold text-[#1B5E20]">à partir de {price}</strong>
      <span className="text-[#5C705E]">· devis gratuit et personnalisé</span>
    </div>
  );
}
